import * as React from 'react';
import { withFormContext } from '../../../../containers/FormContextHandler';
import DiagnosisForm from './DiagnosisForm';
import EtiologyForm from './EpilepsyForm/Etiology';
import SeizureTypeForm from './EpilepsyForm/SeizureType';
import SyndromeForm from './EpilepsyForm/Syndrome';
import HTTForm from './HuntingtonForm/HTT';
import HuntingtonSymptomsForm from './HuntingtonForm/HuntingtonSymptoms';
import UHDRS from './HuntingtonForm/UHDRS';
import MGFAForm from './MgravisForm/MGFA';
import MgravisSymptoms from './MgravisForm/MgravisSymptoms';
import MSDiagnosticCriteria from './MSForm/MsDiagnosticsCriteria/MS';
import NMOSDDiagnosticCriteria from './MSForm/MsDiagnosticsCriteria/NMOSD';
import MsSymptomsForm from './MSForm/MsSymptoms';
import ContraIndicationsToTreatment from './NINMTForm/ContraIndicationsToTreatment';
import IndicationForTreatmentForm from './NINMTForm/IndicationForTreatment';
import ReferringPhysicianAndUnitForm from './NINMTForm/ReferringPhysicianAndUnit';
import SymptomsAndLocations from './NINMTForm/SymptomsAndLocations';
import SymptomsDetails from './NINMTForm/SymptomsDetails';
import AlzheimerForm from './ParkinsonForm/Alzheimer';
import CBDForm from './ParkinsonForm/CBD';
import DLBForm from './ParkinsonForm/DLB';
import FTDForm from './ParkinsonForm/FTD';
import MSAForm from './ParkinsonForm/MSA';
import ParkinsonSymptomForm from './ParkinsonForm/ParkinsonsSymptoms';
import PDForm from './ParkinsonForm/PD';
import PPAForm from './ParkinsonForm/PPA';
import PSPForm from './ParkinsonForm/PSP';
import FirstVisitRespiratoryForm from './SleepApneaForm/FirstVisitRespiratory';
import FirstVisitSleepApneaForm from './SleepApneaForm/FirstVisitSleepApnea';
import PerformanceRatingForm from './SleepApneaForm/PerformanceRating';
import PolyneuroSymptoms from './PolyneuroForm/PolyneuroSymptoms';
import PolyneuroEtiology from './PolyneuroForm/PolyneuroEtiology';
import PolyneuroUnderlyingCondition from './PolyneuroForm/PolyneuroUnderlyingCondition';
import SleepApneaSeverityForm from './SleepApneaForm/SleepApneaSeverity';

import type { IFormContext } from '../../../../containers/FormContextHandler';

const FormComponent = ({
  documents,
  editing,
  view,
  setDiagnosisSelected,
}: IFormContext & {
  setDiagnosisSelected?: React.Dispatch<React.SetStateAction<boolean>>;
}): React.JSX.Element => {
  const documentType = documents?.find(d => d._id === editing || d._id === view?.viewing)?._type;
  switch (documentType) {
    case 'diagnosis':
      return <DiagnosisForm setDiagnosisSelected={setDiagnosisSelected} />;
    case 'msSymptoms':
      return <MsSymptomsForm />;
    case 'msDiagnosticCriteria':
      return <MSDiagnosticCriteria />;
    case 'nmosdDiagnosticCriteria':
      return <NMOSDDiagnosticCriteria />;
    case 'parkinsonSymptoms':
      return <ParkinsonSymptomForm />;
    case 'pd':
      return <PDForm />;
    case 'msa':
      return <MSAForm />;
    case 'psp':
      return <PSPForm />;
    case 'dlb':
      return <DLBForm />;
    case 'cbd':
      return <CBDForm />;
    case 'ftd':
      return <FTDForm />;
    case 'ppa':
      return <PPAForm />;
    case 'alzheimer':
      return <AlzheimerForm />;
    case 'huntingtonSymptoms':
      return <HuntingtonSymptomsForm />;
    case 'htt':
      return <HTTForm />;
    case 'uhdrsConfidenceIndex':
      return <UHDRS />;
    case 'seizureType':
      return <SeizureTypeForm />;
    case 'syndrome':
      return <SyndromeForm />;
    case 'etiology':
      return <EtiologyForm />;
    case 'sleepApneaFirstVisit':
      return <FirstVisitSleepApneaForm />;
    case 'respiratoryFirstVisit':
      return <FirstVisitRespiratoryForm />;
    case 'sleepApneaSeverity':
      return <SleepApneaSeverityForm />;
    case 'performanceRating':
      return <PerformanceRatingForm />;
    case 'indicationForTreatment':
      return <IndicationForTreatmentForm />;
    case 'contraIndicationsToTreatment':
      return <ContraIndicationsToTreatment />;
    case 'symptomsDetails':
      return <SymptomsDetails />;
    case 'symptomsAndLocations':
      return <SymptomsAndLocations />;
    case 'referringPhysicianAndUnit':
      return <ReferringPhysicianAndUnitForm />;
    case 'mgravisSymptoms':
      return <MgravisSymptoms />;
    case 'mgfa':
      return <MGFAForm />;
    case 'polyneuroSymptoms':
      return <PolyneuroSymptoms />;
    case 'polyneuroEtiology':
      return <PolyneuroEtiology />;
    case 'polyneuroUnderlyingCondition':
      return <PolyneuroUnderlyingCondition />;
    default:
      return <React.Fragment />;
  }
};

const Form = withFormContext(FormComponent);

export default Form;
